import { useState, useEffect } from "react";
import Alerts from "./Alerts";
import { useNavigate } from "react-router-dom";
import {
  resendUserOtp,
  updateCustomerOnboardingStat,
  verifyUserOtp,
} from "../services/PrequalificationService";
import { useDispatch, useSelector } from "react-redux";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import useModal from "../hooks/useModal";
import useCustomAlert from "./Alert2";
import useLoader from "../customHooks/useLoader";
import { SpinnerIcon } from "../utils/Loader";
import PageWrapper from "../layouts/Index";
import PageTitle from "./PageTitle";

const ValidateOTP = ({ title, proccessType }) => {
  const [otpValue, setOtpValue] = useState("");
  const [btnLabel, setBtnLabel] = useState("PROCEED");
  const [isLoading, setIsLoading] = useState(null);
  const [err, setErr] = useState(false);
  const [errTitle, setErrTitle] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [userTypePre, setUserTypePre] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storePrecustomer = useSelector(
    (state) => state?.precustomer?.precustomerData
  );
  const [Modal, showModal] = useModal();
  const [otpLoading, setOtpLoading] = useState(false);
  const customAlert = useCustomAlert();
  const [loader, showLoader] = useLoader(SpinnerIcon);
  const [loader2, showLoader2] = useLoader(SpinnerIcon);
  const [storageItem, setStorageItem] = useState({
    partnerid: "",
    customertype: "",
  });
  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);

  // To handle resending of OTP
  const sendOTP = async () => {
    setMsg("");
    setOtpLoading(true);
    showLoader2(true);
    setLoading(true);

    const payload = {
      msisdn: String(storePrecustomer.precustomer.msisdn),
      accountNumber: String(storePrecustomer.precustomer?.accountNumber || storePrecustomer.precustomer?.bvn || ""),
    }
    
    // Make api now to prequalify customer
    const res = await resendUserOtp(payload);

    if (res.status === true) {
      // Trigger alert
      customAlert.showToast("success", res?.message || "OTP sent...!");
      showLoader2(false);
      setLoading(false);
    } else {
      // Trigger alert
      customAlert.showToast("error", "Operation failed...!");
      showLoader2(false);
      setLoading(false);
    }
    setOtpLoading(false);
    setLoading(false);
  };

  // To validate OTP now
  const validateOTP = async (e) => {
    e.preventDefault();

    showLoader(true);
    setLoading(true);
    setMsg("");
    setBtnLabel("Validating...");
    
    const validateOtpPayload = {
      telcoName: Number(storePrecustomer.precustomer?.telco) || 1,
      nin: String(storePrecustomer.precustomer?.idNumber || storePrecustomer.precustomer?.nin || ""),
      bvn: String(storePrecustomer.precustomer?.accountNumber || storePrecustomer.precustomer?.bvn || ""),
      msisdn: String(storePrecustomer.precustomer?.msisdn || ""),
      otp: String(otpValue),
      partnerid: Number(storageItem.partnerid)|| 407,
      customertype: Number(userTypePre.customerType)|| 2,
      customertype_sub: Number(userTypePre?.customerType_sub) || 2,
    };


    // // Make api now to prequalify customer
    const res = await verifyUserOtp(validateOtpPayload);
    console.log("verify-otp res:", res);

    if (res.status === true) {
      // setBtnLabel("Updating Onboarding Status...");

      //  Make api call to update the onboarding status
      const res2 = await updateCustomerOnboardingStat(
        storePrecustomer.precustomer?.msisdn,
        "OTP_VALIDATED"
      );
 
      if (res2?.status === true) {
        // Trigger alert
        customAlert.showToast(
          "success",
          res?.message || "OTP validation successful...!"
        );

        setMsg(res?.message);
        setMsgType("success");
        setBtnLabel("Proceed");
        setLoading(false);

        setTimeout(() => {
          // Update pre_customer state in store and redirect to liveness check page
          if (
            dispatch(
              updatePrecustomer({
                precustomer: {
                  ...storePrecustomer?.precustomer,
                  userType: userTypePre?.customerType,
                  userType_sub: userTypePre?.customerType_sub || "0",
                  partnerid: storageItem.partnerid,
                  precustomerinfo: res?.data?.precustomerinfo,
                  creditLimit: res?.data?.creditLimit,
                },
                onboarding_status: "oxygen-device-bundles",
              })
            )
          ) {
            // Redirect to the next screen
            navigate("/fbn-device-bundles");
          }
        }, [4000]);
      } else {
        setMsg("Failed to update onboarding status..!");
        setMsgType("danger");
        setBtnLabel("TRY AGAIN");
        setLoading(false);
        customAlert.showToast("error", "Failed to update onboarding status..!");
      }
    }
     else {
      setMsg(res?.message || "OTP validation failed...!");
      setMsgType("danger");
      setBtnLabel("PROCEED");
      setLoading(false);
      customAlert.showToast(
        "error",
        res?.message || "OTP validation failed...!"
      );
    }
    showLoader(false);
    setLoading(false);
  };

  useEffect(() => {
    // Get partnerid from local storage
    const partnerid = JSON.parse(localStorage.getItem("allAboard-partnerid"));

    // Update State
    setStorageItem({
      ...storageItem,
      partnerid,
    });

    // Get type from local storage if it exists
    let userInStorage = localStorage.getItem("allAboard-userType");
    const userTypeStorage = userInStorage ? JSON.parse(userInStorage) : null;
    setUserTypePre(userTypeStorage);
  }, []);

  return (
    <PageWrapper>
      <PageTitle title="Validate OTP" />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <h4>
                <b>{title}</b>
              </h4>

              {/* Alert - starts  */}
              {msg && (
                <Alerts
                  alertType={msgType}
                  title={`OTP Validation ${
                    msgType === "danger" ? "Failed" : "Successful"
                  }`}
                  message={msg}
                />
              )}

              {proccessType === "account_creation" ? (
                <>
                  <p>
                    By accepting, you pre-authorize NMB and partners to use your
                    data to create an account and loan for device financing.
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Facilisi cras fermentum odio eu feugiat pretium nibh
                    ipsum. Tincidunt ornare massa eget egestas purus viverra
                    accumsan in nisl. Cursus risus at ultrices mi tempus
                    imperdiet nulla malesuada pellentesque. Sollicitudin nibh
                    sit amet commodo nulla facilisi. Eu augue ut lectus arcu
                    bibendum. Convallis a cras semper auctor neque vitae.
                  </p>
                  <p>
                    By accepting, you pre-authorize NMB and partners to use your
                    data to create an account and loan for device financing.
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Facilisi cras fermentum odio eu feugiat pretium nibh
                    ipsum. Tincidunt ornare massa eget egestas purus viverra
                    accumsan in nisl. Cursus risus at ultrices mi tempus
                    imperdiet nulla malesuada pellentesque. Sollicitudin nibh
                    sit amet commodo nulla facilisi. Eu augue ut lectus arcu
                    bibendum. Convallis a cras semper auctor neque vitae.
                  </p>
                </>
              ) : (
                <>
                  <p>
                    Welcome to Free Smartphone Subscription Plan enabling you to
                    get a super smartphone and bundle without breaking the bank.
                  </p>
                  <p>
                    By accepting, you agree and give your permission to
                    Intelligra and partners to store and process the personal
                    information submitted in accordance with our Terms and
                    Conditions linked here or by visiting our partner's Shop
                    close to you.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body text-center">
              {Modal}

              {err && (
                <Alerts alertType="danger" title={errTitle} message={errMsg} />
              )}
              <div className="col-md-12 justify-content-xl-center">
                <div className="row justify-content-center">
                  <div className="col-md-6 d-flex justify-content-center">
                    <div className="terms">
                      <form onSubmit={validateOTP}>
                        <div className="form-group">
                          <label className="form-label">
                            Enter OTP to consent to the terms and Conditions
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="eg. xxxxxx"
                            value={otpValue}
                            onChange={(e) => setOtpValue(e.target.value)}
                            required
                          />
                        </div>

                        <button
                          type="button"
                          className="btn btn-dark text-white mr-3"
                          disabled={loading}
                          onClick={sendOTP}
                        >
                          {"Resend OTP"} {loader2}
                        </button>

                        <button
                          type="submit"
                          className="btn btn-primary text-white"
                          disabled={loading}
                        >
                          {btnLabel} {loader}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ValidateOTP;
